import { PANELS } from '@panels/constants';
// TODO: Remove this once we have a proper solution for RNI-6064
// WORKAROUND: Prevent Rollup tree-shaking of PANELS import (RNI-6064)
console.log(PANELS);
export const SIDE_PANEL_FRAME_ID = 'side-panel-frame';

export const BLOCKS = {
  STUDENT_HEADER: 'student_header_block',
  DUE_DATE_EDIT: 'due_date_edit_block',
  STUDENT_PERFORMANCE: 'student_performance_block',
  ASSIGNMENT_DETAILS: 'assignment_details_block',
  NOTES: 'notes_block',
  ACTIVITY_LAUNCHES: 'activity_launches_block',
  ASSIGNMENT_HEADER: 'assignment_header_block',
  EXTENSIONS_AND_ACCOMMODATIONS: 'extensions_and_accommodations_block',
};

export const studentBlocks = [
  BLOCKS.STUDENT_HEADER,
  BLOCKS.DUE_DATE_EDIT,
  BLOCKS.STUDENT_PERFORMANCE,
  BLOCKS.ASSIGNMENT_DETAILS,
  BLOCKS.NOTES,
  BLOCKS.ACTIVITY_LAUNCHES,
];

export const assignmentBlocks = [
  BLOCKS.ASSIGNMENT_HEADER,
  BLOCKS.DUE_DATE_EDIT,
  BLOCKS.ASSIGNMENT_DETAILS,
  BLOCKS.EXTENSIONS_AND_ACCOMMODATIONS,
];

export const refreshGradebookEvents = [
  PANELS.STUDENT_PERFORMANCE_UPDATED_SCORE,
  PANELS.ASSIGNMENT_DUE_DATE_UPDATED,
  PANELS.EXTENSION_DUE_DATE_UPDATED,
];
